"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/other-pages/pricing/pricing.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type Pricing46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "card pricing-card w-100" | "card pricing-card active w-100" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/icons/price-icon1.svg" | "/Templates/Doccure/img/icons/price-icon2.svg" | "/Templates/Doccure/img/icons/price-icon3.svg" */
    src: string;
    /** Detected variants: "Basic" | "Premium" | "Enterprise" */
    h40Text: ReactNode;
    /** Detected variants: "For individuals" | "For startups" | "For big companies" */
    p0Text: ReactNode;
    /** Detected variants: "Popular" */
    span0Text?: ReactNode;
    /** Detected variants: "badge" */
    span0ClassName?: string;
    /** Detected variants: "$99" | "$199" | "$399" */
    h20Text: ReactNode;
    /** Detected variants: "col-lg-4 col-md-6" */
    divClassName?: string;
    /** Detected variants: "card-body" */
    div0ClassName?: string;
    /** Detected variants: "pricing-header" */
    div0ClassName2?: string;
    /** Detected variants: "pricing-header-info" */
    div0ClassName3?: string;
    /** Detected variants: "pricing-icon" */
    div0ClassName4?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "pricing-title" */
    div1ClassName?: string;
    /** Detected variants: "pricing-info" */
    div1ClassName2?: string;
    /** Detected variants: "pricing-amount" */
    div0ClassName5?: string;
    /** Detected variants: "/monthly" */
    span0Span0Text?: ReactNode;
    /** Detected variants: "What’s included" */
    h60Text?: ReactNode;
    /** Detected variants: "pricing-list" */
    div1ClassName3?: string;
    /** Detected variants: "pricing-btn" */
    div2ClassName?: string;
    /** Detected variants: "Choose Plan" */
    link0Text?: ReactNode;
    /** Detected variants: "btn btn-primary" */
    link0ClassName?: string;
    /** Detected variants: "all_routes.loginEmail" */
    href?: string;
    pricingListItems?: PricingUls2Item[];
};

type PricingUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "Profile Creation" | "Appointment Booking" | "Notification Alerts" | "Limited Telemedicine Access" | "Extended Telemedicine Access" | "Exclusive Discounts" | "Appointment History" | "Priority Customer Support" | "All Basic plan features" | "All Premium plan features" | "Personalized Health Insights" | "Family Account Management" */
    liText: ReactNode;
};
export type PricingSectionGeneratedProps = {
    divDiv0Div0Div0Div0Div0Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: Pricing46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Div0Div0Div1H40H4Props?: Partial<ComponentProps<"h4">> | ((item: Pricing46sItem) => Partial<ComponentProps<"h4">>);
    divDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">> | ((item: Pricing46sItem) => Partial<ComponentProps<"h2">>);
    divDiv0Div0Div1Div0H60H6Props?: Partial<ComponentProps<"h6">> | ((item: Pricing46sItem) => Partial<ComponentProps<"h6">>);
    divDiv0Div0Div1Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: Pricing46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "Monthly" */
    sectionDiv0Div0Div0Div0Div0Label0LabelText?: ReactNode;
    /** Default: "Yearly" */
    sectionDiv0Div0Div0Div0Div0Label1LabelText?: ReactNode;
    /** Default: "Our Pricing Plan" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    pricing46s: Pricing46sItem[];
    pricing46sItemWrapper?: (item: Pricing46sItem, content: ReactNode) => ReactNode;
    pricing46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    pricing46sLinkVisible?: boolean;
    pricing46sLinkRenderer?: (item: Pricing46sItem, defaultNode: ReactNode) => ReactNode;
    pricing46sImageVisible?: boolean;
    pricing46sImageRenderer?: (item: Pricing46sItem, defaultNode: ReactNode) => ReactNode;
    pricing46sH2Visible?: boolean;
    pricing46sH2Renderer?: (item: Pricing46sItem, defaultNode: ReactNode) => ReactNode;
    pricing46sH4Visible?: boolean;
    pricing46sH4Renderer?: (item: Pricing46sItem, defaultNode: ReactNode) => ReactNode;
    pricing46sH6Visible?: boolean;
    pricing46sH6Renderer?: (item: Pricing46sItem, defaultNode: ReactNode) => ReactNode;
    pricing46sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: Pricing46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    pricing46sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: Pricing46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    pricing46sH2Props?: Partial<ComponentProps<"h2">> | ((item: Pricing46sItem) => Partial<ComponentProps<"h2">>);
    pricing46sH4Props?: Partial<ComponentProps<"h4">> | ((item: Pricing46sItem) => Partial<ComponentProps<"h4">>);
    pricing46sH6Props?: Partial<ComponentProps<"h6">> | ((item: Pricing46sItem) => Partial<ComponentProps<"h6">>);
    pricingUls2ItemWrapper?: (item: PricingUls2Item, content: ReactNode) => ReactNode;
    pricingUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
};

const PricingSectionGenerated: FC<PricingSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Label0LabelText = "Monthly",
    sectionDiv0Div0Div0Div0Div0Label1LabelText = "Yearly",
    sectionDiv0Div0Div0Div0H20H2Text = "Our Pricing Plan",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    divDiv0Div0Div0Div0Div0Span0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0Div0Div1H40H4Props,
    divDiv0Div0Div1Div0H20H2Props,
    divDiv0Div0Div1Div0H60H6Props,
    divDiv0Div0Div1Div2Link0LinkProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div1ClassName,
    pricing46s,
    pricing46sItemWrapper,
    pricing46sRenderer,
    pricing46sLinkVisible,
    pricing46sLinkRenderer,
    pricing46sImageVisible,
    pricing46sImageRenderer,
    pricing46sH2Visible,
    pricing46sH2Renderer,
    pricing46sH4Visible,
    pricing46sH4Renderer,
    pricing46sH6Visible,
    pricing46sH6Renderer,
    pricing46sLinkProps,
    pricing46sImageProps,
    pricing46sH2Props,
    pricing46sH4Props,
    pricing46sH6Props,
    pricingUls2ItemWrapper,
    pricingUls2Renderer,
}) => {
    return (
        <section className="pricing-section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-md-12 text-center">
                        <div className="section-inner-header pricing-inner-header">
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0H20H2Text}</h2>
                            ))}
                            <div className="plan-choose-info">
                                <label className="monthly-plan">{sectionDiv0Div0Div0Div0Div0Label0LabelText}</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" role="switch" defaultChecked />
                                </div>
                                <label className="yearly-plan">{sectionDiv0Div0Div0Div0Div0Label1LabelText}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row align-items-center justify-content-center"}>
                    {renderCollectionNode(
                        pricing46s,
                        (item: Pricing46sItem) => (
                            <div className={item.divClassName ?? "col-lg-4 col-md-6"} key={item.key}>
                                <div className={item.className}>
                                    <div className={item.div0ClassName ?? "card-body"}>
                                        <div className={item.div0ClassName2 ?? "pricing-header"}>
                                            <div className={item.div0ClassName3 ?? "pricing-header-info"}>
                                                <div className={item.div0ClassName4 ?? "pricing-icon"}>
                                                    <span>
                                                        {renderItemNode(pricing46sImageVisible, pricing46sImageRenderer, item, (
                                                            <SmartImage src={item.src} alt={item.alt ?? "icon"} {...(typeof pricing46sImageProps === "function" ? pricing46sImageProps(item) : (pricing46sImageProps ?? {}))} {...(typeof divDiv0Div0Div0Div0Div0Span0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0Div0Div0Span0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0Div0Div0Span0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </span>
                                                </div>
                                                <div className={item.div1ClassName ?? "pricing-title"}>
                                                    <p>{item.p0Text}</p>
                                                    {renderItemNode(pricing46sH4Visible, pricing46sH4Renderer, item, (
                                                        <h4 {...(typeof pricing46sH4Props === "function" ? pricing46sH4Props(item) : (pricing46sH4Props ?? {}))} {...(typeof divDiv0Div0Div0Div0Div1H40H4Props === "function" ? divDiv0Div0Div0Div0Div1H40H4Props(item) : (divDiv0Div0Div0Div0Div1H40H4Props ?? {}))}>{item.h40Text}</h4>
                                                    ))}
                                                </div>
                                            </div>
                                            <div>
                                                <span className={item.span0ClassName}>{item.span0Text}</span>
                                            </div>
                                        </div>
                                        <div className={item.div1ClassName2 ?? "pricing-info"}>
                                            <div className={item.div0ClassName5 ?? "pricing-amount"}>
                                                {renderItemNode(pricing46sH2Visible, pricing46sH2Renderer, item, (
                                                    <h2 {...(typeof pricing46sH2Props === "function" ? pricing46sH2Props(item) : (pricing46sH2Props ?? {}))} {...(typeof divDiv0Div0Div1Div0H20H2Props === "function" ? divDiv0Div0Div1Div0H20H2Props(item) : (divDiv0Div0Div1Div0H20H2Props ?? {}))}>
                                                        {item.h20Text}
                                                        <span>{item.span0Span0Text ?? "/monthly"}</span>
                                                    </h2>
                                                ))}
                                                {renderItemNode(pricing46sH6Visible, pricing46sH6Renderer, item, (
                                                    <h6 {...(typeof pricing46sH6Props === "function" ? pricing46sH6Props(item) : (pricing46sH6Props ?? {}))} {...(typeof divDiv0Div0Div1Div0H60H6Props === "function" ? divDiv0Div0Div1Div0H60H6Props(item) : (divDiv0Div0Div1Div0H60H6Props ?? {}))}>{item.h60Text ?? "What’s included"}</h6>
                                                ))}
                                            </div>
                                            <div className={item.div1ClassName3 ?? "pricing-list"}>
                                                <ul>
                                                    {renderCollectionNode(
                                                        item.pricingListItems ?? [],
                                                        (item: PricingUls2Item) => (
                                                            <li key={item.key}>{item.liText}</li>
                                                        ),
                                                        pricingUls2ItemWrapper,
                                                        pricingUls2Renderer
                                                    )}
                                                </ul>
                                            </div>
                                            <div className={item.div2ClassName ?? "pricing-btn"}>
                                                {renderItemNode(pricing46sLinkVisible, pricing46sLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "all_routes.loginEmail"} className={item.link0ClassName ?? "btn btn-primary"} {...(typeof pricing46sLinkProps === "function" ? pricing46sLinkProps(item) : (pricing46sLinkProps ?? {}))} {...(typeof divDiv0Div0Div1Div2Link0LinkProps === "function" ? divDiv0Div0Div1Div2Link0LinkProps(item) : (divDiv0Div0Div1Div2Link0LinkProps ?? {}))}>{item.link0Text ?? "Choose Plan"}</SmartLink>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        pricing46sItemWrapper,
                        pricing46sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default PricingSectionGenerated;
